import React, { useState } from 'react';
import { XIcon } from '@heroicons/react/solid';

function Banner({ legacyBalance, postCredits, onDismiss }) {
  const [showModal, setShowModal] = useState(false);

  // Only show if user has BOTH postCredits AND legacyBalance
  if (!postCredits || postCredits <= 0 || !legacyBalance || legacyBalance <= 0) return null;

  return (
    <>
      <div className="mx-4 sm:mx-6 lg:mx-8 mt-0">
        <div className="flex items-center gap-x-6 bg-primary px-6 py-3 rounded-md sm:px-3.5 sm:before:flex-1">
          <p className="text-sm text-white">
            <strong className="font-semibold">Payment system updated</strong>
            <svg viewBox="0 0 2 2" aria-hidden="true" className="mx-2 inline h-0.5 w-0.5 fill-current">
              <circle r={1} cx={1} cy={1} />
            </svg>
            Account balance: <span className="font-semibold">${legacyBalance.toFixed(2)}</span>
            <button
              onClick={() => setShowModal(true)}
              className="ml-2 underline hover:text-red-200 focus:outline-none"
            >
              Learn more <span aria-hidden="true">&rarr;</span>
            </button>
          </p>
          <div className="flex flex-1 justify-end">
            <button
              type="button"
              onClick={onDismiss}
              className="-m-3 p-3 focus:outline-none"
            >
              <span className="sr-only">Dismiss</span>
              <XIcon aria-hidden="true" className="h-5 w-5 text-white" />
            </button>
          </div>
        </div>
      </div>

      {/* Learn More Modal */}
      {showModal && (
        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" onClick={() => setShowModal(false)}></div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
                    <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">
                      Payment System Updates
                    </h3>
                    <div className="mt-2 space-y-3 text-sm text-gray-500">
                      <p>
                        <strong className="text-gray-900">What's Changed:</strong>
                      </p>
                      <ul className="list-disc list-inside space-y-2 ml-2">
                        <li>No more credits – pay directly for job postings</li>
                        <li>Extended timeline options: 91, 181, or 365 days</li>
                        <li>Flexible pricing based on posting duration</li>
                      </ul>

                      <p className="pt-3">
                        <strong className="text-gray-900">Your Account Balance:</strong>
                      </p>
                      <p>
                        Your purchased credits have been converted to account balance at $30.00 per credit. Your current balance of <strong className="text-gray-900">${legacyBalance.toFixed(2)}</strong> will be applied to future job postings.
                      </p>

                      <p className="pt-3 text-xs">
                        Questions or concerns? Contact us at <a href="mailto:enquiries@canadajobleads.ca" className="font-medium text-primary hover:underline">enquiries@canadajobleads.ca</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Got it
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Banner;
